import axios from '@axios';

const base = '/api/v1/prison-users';

export default {
  login(username, password) {
    return axios.post(`${base}/tokens`, { username, password });
  },
  getUser() {
    return axios.get(`${base}/user`);
  },
  getClinicians() {
    return axios.get(`${base}/clinicians-for-prison`);
  },
  changePassword(currentPassword, newPassword) {
    return axios.post(`${base}/change-password`, { currentPassword, newPassword })
  },
};
